module.exports = __webpack_public_path__ + "static/media/contentExample5.9368bff6.png";